export type MalayLandingLangCode = 'ms' | 'en';

export const MALAY_LANDING_LANGUAGE_OPTIONS: ReadonlyArray<{
  code: MalayLandingLangCode;
  shortLabel: 'MS' | 'EN';
  fullLabel: string;
}> = [
  { code: 'ms', shortLabel: 'MS', fullLabel: 'Bahasa Melayu' },
  { code: 'en', shortLabel: 'EN', fullLabel: 'English' },
];

/** Visible short code for the Malay public landing language selector (MS / EN). */
export function malayLandingLanguageDisplayCode(code: string): string {
  const normalized = code.trim().toLowerCase();
  if (normalized.startsWith('ms')) return 'MS';
  if (normalized.startsWith('en')) return 'EN';
  return code.toUpperCase();
}

/** Full language name for accessibility metadata on the landing selector. */
export function malayLandingLanguageFullLabel(code: string): string {
  const normalized = code.trim().toLowerCase();
  if (normalized.startsWith('ms')) return 'Bahasa Melayu';
  if (normalized.startsWith('en')) return 'English';
  return code;
}
